import { render, staticRenderFns } from "./ProjectStatusDialog.vue?vue&type=template&id=70ede3ea&scoped=true&"
import script from "./ProjectStatusDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatusDialog.vue?vue&type=style&index=0&id=70ede3ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ede3ea",
  null
  
)

export default component.exports